import React from "react";
import {CreateCategory} from "./CreateCategory";

export class EditCategory extends CreateCategory {
    protected needMount: boolean = true;

    protected getRequestUrl(): RequestInfo | URL {
        return '/product-category/update';
    }

    protected onSuccess(data: any, event: React.FormEvent | null): any {
        this.setState(null);
        (document.querySelector('form .alert.alert-success') as HTMLElement).classList.remove('hide');
    }
}
